var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"CancelButton",attrs:{"type":"warning"},on:{"click":function () { return !_vm.isNotRedirect? _vm.handleCancelEvent() : _vm.handleCancelClick(); }}},[_vm._v("\n  Anuluj\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdaea42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/CancelButton/index.vue
// module id = 312
// module chunks = 0